// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-slider-container {
  position:fixed;
  padding-top:6em;
  height: 100vh;
  z-index:99999;
  inset:0;
  background:rgba(0,0,0,.95);
  width: 100vw; /* Fills mobile screen width */
  max-width: 480px; /* Standard mobile breakpoint safeguard */
  margin: 0 auto;
}

/* Viewport optimized strictly for natural mobile finger swiping */
.mobile-slider-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow-x: auto;
  
  /* Forces physics-based native mobile deceleration elastic bounce */
  -webkit-overflow-scrolling: touch; 
  
  /* Hardware-accelerated smooth snapping */
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  
  /* Hide scrollbars completely across mobile operating systems */
  -ms-overflow-style: none;  /* IE/Edge mobile */
  scrollbar-width: none;  /* Firefox mobile */
}

.mobile-slider-wrapper::-webkit-scrollbar {
  display: none; /* iOS Safari & Android Chrome */
}

/* Flexbox track layout */
.mobile-slider-carousel {
  display: flex;
  list-style: none;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* Individual full-screen slide elements */
.mobile-slider-card {
  min-width: 100%;
  height: 100%;
  scroll-snap-align: center;
  scroll-snap-stop: always; /* Prevents user from skipping past slides accidentally */
}

.mobile-slider-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  
  /* Blocks system UI menus from opening on long-press */
  pointer-events: none;
  -webkit-touch-callout: none; 
  user-select: none;
}

/* Dynamic Pagination Dots Styles */
.mobile-slider-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
}

.mobile-slider-dots .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ccc;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.mobile-slider-dots .dot.active {
  background-color: #007bff;
  transform: scale(1.2);
}

`, "",{"version":3,"sources":["webpack://./src/Report/css/MobileSlider.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,aAAa;EACb,OAAO;EACP,0BAA0B;EAC1B,YAAY,EAAE,8BAA8B;EAC5C,gBAAgB,EAAE,yCAAyC;EAC3D,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;;EAEhB,mEAAmE;EACnE,iCAAiC;;EAEjC,yCAAyC;EACzC,6BAA6B;EAC7B,uBAAuB;;EAEvB,+DAA+D;EAC/D,wBAAwB,GAAG,mBAAmB;EAC9C,qBAAqB,GAAG,mBAAmB;AAC7C;;AAEA;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,wBAAwB,EAAE,yDAAyD;AACrF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;;EAEjB,sDAAsD;EACtD,oBAAoB;EACpB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".mobile-slider-container {\n  position:fixed;\n  padding-top:6em;\n  height: 100vh;\n  z-index:99999;\n  inset:0;\n  background:rgba(0,0,0,.95);\n  width: 100vw; /* Fills mobile screen width */\n  max-width: 480px; /* Standard mobile breakpoint safeguard */\n  margin: 0 auto;\n}\n\n/* Viewport optimized strictly for natural mobile finger swiping */\n.mobile-slider-wrapper {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow-x: auto;\n  \n  /* Forces physics-based native mobile deceleration elastic bounce */\n  -webkit-overflow-scrolling: touch; \n  \n  /* Hardware-accelerated smooth snapping */\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  \n  /* Hide scrollbars completely across mobile operating systems */\n  -ms-overflow-style: none;  /* IE/Edge mobile */\n  scrollbar-width: none;  /* Firefox mobile */\n}\n\n.mobile-slider-wrapper::-webkit-scrollbar {\n  display: none; /* iOS Safari & Android Chrome */\n}\n\n/* Flexbox track layout */\n.mobile-slider-carousel {\n  display: flex;\n  list-style: none;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* Individual full-screen slide elements */\n.mobile-slider-card {\n  min-width: 100%;\n  height: 100%;\n  scroll-snap-align: center;\n  scroll-snap-stop: always; /* Prevents user from skipping past slides accidentally */\n}\n\n.mobile-slider-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  \n  /* Blocks system UI menus from opening on long-press */\n  pointer-events: none;\n  -webkit-touch-callout: none; \n  user-select: none;\n}\n\n/* Dynamic Pagination Dots Styles */\n.mobile-slider-dots {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.mobile-slider-dots .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #ccc;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.mobile-slider-dots .dot.active {\n  background-color: #007bff;\n  transform: scale(1.2);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
